const MAX_SESSION_IDS = 20;
const MAX_FILE_IDS = 300;

const pushId = (list, seen, value, limit) => {
  const id = typeof value === 'string' ? value.trim() : '';
  if (!id || id.includes('/') || seen.has(id) || list.length >= limit) return;
  seen.add(id);
  list.push(id);
};

/**
 * 지울 대화 문서·메시지에서 첨부 정리 요청에 실을 세션 id·파일 id 를 모은다.
 * 서버가 소유자·자료함·다른 대화 사용 여부를 다시 확인하므로 여기서는 모으기만 한다.
 */
export function collectConversationAttachmentRefs(conversationData, messagesData = [], extraSessionIds = []) {
  const sessionIds = [];
  const sessionSeen = new Set();
  pushId(sessionIds, sessionSeen, conversationData?.sessionId, MAX_SESSION_IDS);
  extraSessionIds.forEach((sid) => pushId(sessionIds, sessionSeen, sid, MAX_SESSION_IDS));

  const fileIds = [];
  const fileSeen = new Set();
  messagesData.forEach((message) => {
    ['attachedFileIds', 'newlyAttachedFileIds'].forEach((key) => {
      const ids = Array.isArray(message?.[key]) ? message[key] : [];
      ids.forEach((fid) => pushId(fileIds, fileSeen, fid, MAX_FILE_IDS));
    });
  });
  return { session_ids: sessionIds, file_ids: fileIds };
}

export function hasConversationAttachmentRefs(refs) {
  return Boolean(refs && (refs.session_ids.length > 0 || refs.file_ids.length > 0));
}
